import axios from 'axios'
const ServiceURL = process.env.VUE_APP_SERVICEURL

export default {
    name: 'notification',
    state: {
        notification: {
            aksi: [],
            informasi: []
        },
        notificationView: false
    },
    getters: {
        getNotification: state => {
            return state.notification
        },
        getNotificationView: state => {
            return state.notificationView
        }
    },
    mutations: {
        NOTIFICATION: (state, payload) => {
            if (payload[0] !== undefined) {
                state.notification.aksi = payload[0].data.data;
            } else {
                state.notification.aksi = [];
            }
            if (payload[1] !== undefined) {
                state.notification.informasi = payload[1].data.data;
            } else {
                state.notification.informasi = [];
            }
        },
        NOTIFICATION_VIEW: (state) => {
            state.notificationView = !state.notificationView
        },
        CLOSE_NOTIFICATION: (state, payload) => {
            state.notificationView = payload
        }
    },
    actions: {
        SET_NOTIFICATION_VIEW(store) {
            store.commit('NOTIFICATION_VIEW')
        },
        CLOSE_NOTIFICATION_VIEW(store, payload) {
            store.commit('CLOSE_NOTIFICATION', payload)
        },
        async FETCH_NOTIFICATION(store) {
            const aksi = axios({
                method: "get",
                url: ServiceURL + "notifikasi/aksi",
                params: {
                    tlc: store.rootState.user.auth.username,
                    aksi: 2
                },
                auth: {
                    username: store.rootState.user.auth.username,
                    password: store.rootState.user.auth.password,
                },
                headers: {
                    "X-API-KEY": store.rootState.user.auth.apikey,
                }
            }).catch(err => {
                console.log(err.response)
            });

            const informasi = axios({
                method: "get",
                url: ServiceURL + "notifikasi/aksi",
                params: {
                    tlc: store.rootState.user.auth.username,
                    aksi: 1
                },
                auth: {
                    username: store.rootState.user.auth.username,
                    password: store.rootState.user.auth.password,
                },
                headers: {
                    "X-API-KEY": store.rootState.user.auth.apikey
                }
            }).catch(err => {
                console.log(err.response)
            });

            await axios
                .all([
                    aksi.catch(err => {
                        return console.log(err.response);
                    }),
                    informasi.catch(err => {
                        return console.log(err.response);
                    })
                ])
                .then(response => {
                    store.commit('NOTIFICATION', response)
                });
        }
    }
}
